import { Button, Form, Input,InputNumber, Radio,Checkbox } from 'antd';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import api from '../../../../../apis';
import { useNavigate } from 'react-router-dom';
import UtradeAgreement from './UtradeAgreement';
import { Outlet, useLocation } from 'react-router-dom';

import { showMessageModal, showSuccessMessageModal } from '../../../../../components/utils';

const Index = ({firstTimeLogin=false}) => {
    let location = useLocation();
    const query = new URLSearchParams(location.search);
    const userID = query.get('user-id');

    const [currentStep, setCurrentStep] = useState("agreement");
    const navigate = useNavigate();
    const [ loading, setLoading ] = useState(false);
    const [form] = Form.useForm();
    const [doneCaptcha, setDoneCaptcha] = useState(false);

    useLayoutEffect(() => {
        if(firstTimeLogin == true){
            setCurrentStep("register-account");
        }

    }, []);


    const [passwordRules, setPasswordRules] = useState([{ 
        required: true, message: 'Please input your password' 
    },{
        
        pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,15}$/,
        message: <div>
            Password must meet ALL of the requirements
        </div>,
    
    }]);

    const [passwordRulesText, setPasswordRulesText] = useState(<div className='d-flex w-100'>
        <div className=''>
            Password must meet ALL of the following requirements ONLY:
            <br/>
            8-15 characters
            <br/>
            At least one Alphabet (Uppercase)
            <br/>
            At least one Alphabet (Lowercase)
            <br/>
            At least one Number
            <br/>
            At least one Symbol
        </div>
    </div>);

    const [usernameRules, setUsernameRules] = useState<any[]>([
        { required: true, message: 'Please input your username' },
        { pattern: /^\S+$/, message: 'Spaces are not allowed' }
    ]);
    const [usernameRulesText, setUsernameRulesText] = useState<React.ReactNode>(null);

    useEffect(() => {
        requestCredentialRules();

        if(userID){
            form.setFieldsValue({
                username: userID
            })
        }
    }, []);

    const onFinish = (v: any) => {
        
        let param =   {
            "username": v.username,
            "password": v.password,
            "type": Number(v.type),
            "identity": v.identity,
            "email": v.email,
            "answers": [v.question1, v.question2, v.question3]
        }

       // console.log('Success:param', param);
        handleRegister(param);
        
    };

    const buildFieldRules = (r: any) => {
        let newRules: any[] = [];
        let newRulesText: any[] = [];

        if (r.min && r.max) {
            newRules.push({
                pattern: new RegExp(`^.{${r.min},${r.max}}$`),
                message: `${r.min}-${r.max} characters`
            });
            newRulesText.push(<div>{r.min}-{r.max} characters</div>);
        }

        if (r.alphabet) {
            if (r.sensitive) {
                newRules.push({ pattern: /[A-Z]/, message: 'At least one Alphabet (Uppercase)' });
                newRules.push({ pattern: /[a-z]/, message: 'At least one Alphabet (Lowercase)' });
                newRulesText.push(<div>At least one Alphabet (Uppercase)</div>);
                newRulesText.push(<div>At least one Alphabet (Lowercase)</div>);
            } 
        }

        if (r.numeric === true) {
            newRules.push({ pattern: /\d/, message: 'At least one Number' });
            newRulesText.push(<div>At least one Number</div>);
        } 

        if (r.symbol === true) {
            newRules.push({  pattern: /[^a-zA-Z0-9\s]/, message: 'At least one Symbol' });
            newRulesText.push(<div>At least one Symbol</div>);
        } else if (r.symbol) {
            // Escape special regex characters inside the symbol string
            const escapedSymbols = r.symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            const symbolRegex = new RegExp(`[${escapedSymbols}]`);

            newRules.push({
                pattern: symbolRegex,
                message: `At least one Symbol (${r.symbol})`
            });

            newRulesText.push(<div>At least one Symbol ({r.symbol})</div>);
        }

        if (r.startWith === 'alphabet') {
            newRules.push({ pattern: /^[A-Za-z]/, message: 'Must start with an alphabet' });
            newRulesText.push(<div>Must start with an alphabet</div>);
        }

        newRules.push({ pattern: /^\S+$/, message: 'Spaces are not allowed' });

        return { rules: newRules, rulesText: newRulesText };
    };

    const requestCredentialRules = async () => {
        let result = await api.userCredentialRules();
  
        if (result.rules) {
            // New format: rules.username and rules.password
            if (result.rules.password) {
                const { rules: pwRules, rulesText: pwRulesText } = buildFieldRules(result.rules.password);
                setPasswordRules([
                    { required: true, message: 'Please input your password' },
                    ...pwRules
                ]);
                setPasswordRulesText(
                    <div className='d-flex w-100'>
                        <div className=''>
                            Password must meet ALL of the following requirements ONLY:
                            {pwRulesText}
                        </div>
                    </div>
                );
            }

            if (result.rules.username && !userID) {
                const { rules: usrRules, rulesText: usrRulesText } = buildFieldRules(result.rules.username);
                setUsernameRules([
                    { required: true, message: 'Please input your username' },
                    ...usrRules
                ]);
                // setUsernameRulesText(
                //     usrRulesText.length > 0 ? (
                //         <div className='d-flex w-100'>
                //             <div className=''>
                //                 User ID must meet ALL of the following requirements:
                //                 {usrRulesText}
                //             </div>
                //         </div>
                //     ) : null
                // );
            }

            // Backward compatibility: old flat format
            if (!result.rules.password && !result.rules.username) {
                const { rules: pwRules, rulesText: pwRulesText } = buildFieldRules(result.rules);
                setPasswordRules([
                    { required: true, message: 'Please input your password' },
                    ...pwRules
                ]);
                setPasswordRulesText(
                    <div className='d-flex w-100'>
                        <div className=''>
                            Password must meet ALL of the following requirements ONLY:
                            {pwRulesText}
                        </div>
                    </div>
                );
            }
        }
    }

    const handleRegister = async (param:any) => {
         
        setLoading(true);

        param.mode = firstTimeLogin == true ? 2 : 0;//2.first time login//0.normal flow

        let result = await api.userRegister(param);
 
         if (result != false && result.status == 0) {
    
            if(firstTimeLogin == true){
               // alert("New password updated successfully. Please log in using your new password on the login page.");
                showSuccessMessageModal("New password updated successfully. Please log in using your new password on the login page.");
            }else{
               // alert("Register successful, please check your mailbox to activate your account");
                showSuccessMessageModal("Register successful, please check your mailbox to activate your account");
            }
             //window.location.reload();
             navigate('/login');
         } else {
             setLoading(false);
         }
     };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    const validateConfirmPassword = (_: any, value: any) => {
        if (!value || form.getFieldValue('password') === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('The two passwords that you entered do not match!'));
    };

    const [selection, setSelection] = useState('0'); // Default selection
    const onSelectionChange = (e: any) => {
        setSelection(e.target.value);
    };

    const onCaptchaChange = (value:any)=>{
        console.log("Captcha value:", value);
        setDoneCaptcha(true);
    }

    const handleNRICChange = (e:any) => {
        const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // Remove non-alphanumeric characters
        form.setFieldsValue({ identity: sanitizedValue }); // Update field value in the form
    };
      
    return (
        <> 
            {currentStep == "agreement" &&
            <UtradeAgreement onNextStep={() => setCurrentStep("register-account")} />
            }
            {
                currentStep == "register-account" &&
                <div className='page-layout w-100 d-flex p-5 justify-content-center align-items-center  register-form'>
                   
                   
                    <Form
                        form={form}
                        name="basic"
                        labelCol={{ span: 12 }}
                        wrapperCol={{ span: 12 }}
                        initialValues={{ 
                            type:"0"
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        style={{
                            width:"100%",
                            maxWidth:"1200px"
                        }}
                    >
                        <div className='title'>Account Information</div>
                        <div className='pt-3'></div>
                        <Form.Item
                            label="User ID"
                            name="username"
                            rules={usernameRules}

                        >
                            <Input disabled={userID?true:false}/>
                        </Form.Item>

                        {usernameRulesText && (
                            <Form.Item wrapperCol={{lg:{ offset: 12, span: 12 }}} >
                                {usernameRulesText}
                            </Form.Item>
                        )}
                
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={passwordRules}
                            
                        >
                            <Input.Password />
                        
                        </Form.Item>
                        
                        
                        <Form.Item
                            label="Confirm Password"
                            name="confirm-password"
                            validateTrigger="onBlur"
                            rules={[
                                { 
                                    required: true, message: 'Please input your confirm password',
                                },
                            { validator: validateConfirmPassword }
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item wrapperCol={{lg:{ offset: 12, span: 12 }}} >
                            {passwordRulesText}
                        </Form.Item>
                    

                        <div className='title'>Member Information</div>
                        <div className='pt-3'></div>

                        {/* <Form.Item
                            label="NRIC"
                            name="nric"
                            rules={[
                                { 
                                    required: true, message: 'Please input your nric',
                                },
                                {
                                    pattern: /^\d+$/,
                                    message: 'Only numbers are allowed!',
                                },
                            ]}
                        >
                            <div className='d-flex h-100'>
                                <div className='col-4'><Form.Item   name="nric-1"><Input maxLength={6}/></Form.Item></div>
                                <div className='col-1'> <div className='pt-1'>-</div> </div>
                                <div className='col-3'><Form.Item name="nric-2"><Input maxLength={2}/></Form.Item></div>
                                <div className='col-1'> <div className='pt-1'>-</div> </div>
                                <div className='col-3'><Form.Item><Input maxLength={4}/></Form.Item></div>
                            </div>
                        </Form.Item> */}

                        <Form.Item
                            label="Select Registration Type"
                            name="type"
                            rules={[{ required: true, message: 'Please select an option!' }]}
                        >
                            <Radio.Group onChange={onSelectionChange}>
                            <Radio value="0">Individual</Radio>
                            <Radio value="1">Corporate</Radio>
                            </Radio.Group>
                        </Form.Item>
                    
                        {selection === '0' && (
                            <>
                            <Form.Item
                                label="NRIC/Passport"
                                name="identity"
                                rules={[{ required: true, message: 'Please enter your NRIC/Passport' }]}
                                extra={<div style={{ color: 'blue' }}>Kindly enter NRIC/Passport Number without hyphen</div>}
                            >

                                <Input placeholder="Enter your NRIC/Passport" onChange={handleNRICChange} />
                             
                            </Form.Item>
                     
                    
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                { required: true, message: 'Please enter your email' },
                                { type: 'email', message: 'Please enter a valid email address!' },
                                ]}
                            >
                                <Input placeholder="Enter your email" />
                            </Form.Item>
                            </>
                        )}

                        {selection === '1' && (
                            <>
                            <Form.Item
                                label="Business Registration"
                                name="identity"
                                rules={[{ required: true, message: 'Please enter your Business Registration!' }]}
                            >
                                <Input placeholder="Enter your Business Registration" onChange={handleNRICChange} />
                            </Form.Item>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                { required: true, message: 'Please enter your email!' },
                                { type: 'email', message: 'Please enter a valid email address!' },
                                ]}
                            >
                                <Input placeholder="Enter your email" />
                            </Form.Item>
                            </>
                        )}
                        {/* <Form.Item
                            label="Mobile Number"
                            name="phone_number"
                            rules={[
                                { required: true, message: 'Please input' },
                                {
                                    pattern: /^\d+$/,
                                    message: 'Only numbers are allowed!',
                                },

                            ]}
                        >
                            <Input />
                        </Form.Item> */}
    
                        <div className='title'>Please Provide your answer to the following questions:</div>
                        <div className='pt-3'></div>
                        <Form.Item
                            label="1. What is your mother's maiden name?"
                            name="question1"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="2. What is your favourite past time?"
                            name="question2"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="3. What is your first job after school?"
                            name="question3"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input />
                        </Form.Item>
{/* 
                        <div className='d-flex justify-content-center'>
                            <ReCAPTCHA
                                sitekey="6Ld1-DMqAAAAAMBuJ8M1G0tV2dJdzaVWTkpYq_9h"
                                onChange={onCaptchaChange}
                            />
                        </div>
         */}
                        
                            {/* {
                                doneCaptcha &&
                                <Form.Item wrapperCol={{ offset: 8, span: 16 }} className='pt-4'>
                                    <div>
                                        <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                            Submit
                                        </Button>
                                    </div>
                                </Form.Item>
                            } */}

                        {/* <Form.Item 
                        // wrapperCol={{lg:{ offset: 8, span: 16 }}} 
                        className='pt-4'>
                            <div style={{textAlign: 'center'}}>
                                <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md' loading={loading}>
                                    Submit
                                </Button>
                            </div>
                        </Form.Item> */}
                        <div className='d-flex justify-content-center'>
                        <Form.Item
                            name="agreement"
                            valuePropName="checked"
                            rules={[
                                {
                                    validator: (_, value) =>
                                        value
                                            ? Promise.resolve()
                                            : Promise.reject(new Error('You must agree to the terms and conditions')),
                                },
                            ]}
                            colon={false}
                            wrapperCol={{ span: 24 }} // override default layout
                        >
                            
                                <Checkbox style={{ textAlign: 'center'}}>
                                    By submitting this registration, I agree to the&nbsp;
                                    <a href="https://www.utrade.com.my/pdf/UOBKH-Securities-TNC-Utrade%20and%20Edoc-v04072025.pdf" target="_blank" rel="noopener noreferrer">
                                        Terms and Conditions
                                    </a> of use of UTRADE services.
                                </Checkbox>
                           
                        </Form.Item>
                        </div>
                          

                     
                        <div style={{textAlign: 'center'}} className='pt-4'>
                                <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md' loading={loading}>
                                    Submit
                                </Button>
                            </div>
                    </Form>
                </div>
            }
            
        </>
    );
};

export default Index;
